module.exports = __webpack_public_path__ + "static/img/285_TO8_2434_og.f97ee21.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/285_TO8_2434_og.jpg
// module id = kfOu
// module chunks = 0